import { Component, OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LanguageData } from './common-class/language-data';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { OfflineSurvey } from './common-class/survey';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Participation';
  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private elementRef: ElementRef, private service: ParticipationDataService,
    private offlineSurvey: OfflineSurvey) {

    let myAttribute = this.elementRef.nativeElement.getAttribute('myAttribute');

    let path = this.elementRef.nativeElement.getAttribute('basePath');

    this.service.emitChange(path, true);
  }

  ngOnInit() {
     //This code work in existing project
     //let path = 'Survey1.aspx?'+ this.elementRef.nativeElement.getAttribute('myAttribute');
     if(this.offlineSurvey != undefined && this.offlineSurvey.isOfflineSurvey){
      let k
      this.activatedRoute.queryParams.subscribe(async params => {
        k = params['k'];
      });

      let path = 'offline.aspx?'+ this.elementRef.nativeElement.getAttribute('myAttribute');
      this.router.navigateByUrl(path);
     }else{
      //This code work in existing project
      let path = 'survey1.aspx?'+ this.elementRef.nativeElement.getAttribute('myAttribute');

      this.router.navigateByUrl(path);
      }
  }
}
